import ErrorFullPage from './ErrorFullPage';

export default ErrorFullPage;
